export default 'https://storage.googleapis.com/hom-frontend-assets/next/assets/bootcamp/activities/long-multi/dot_outlined.svg'
